import Cookies from "js-cookie";

import {
  LOGOUT_SUCCESS,
  LOGIN_FAIL,
  LOGIN_SUCCESS,
  REGISTER_FAIL,
} from "./types";

const initialState = {
  isAuthenticated: false,
  token: null,
  user: {},
  error: "",
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case LOGIN_SUCCESS:
      const expiry = new Date();
      expiry.setDate(expiry.getDate() + 7);
      console.log(expiry);
      Cookies.set("jwt", action.payload.token, { expires: expiry });
      return {
        ...state,
        isAuthenticated: true,
        token: action.payload.token,
        user: action.payload.user,
        error: "",
      };
    case LOGIN_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        token: "",
        user: {},
        error: action.payload,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isAuthenticated: false,
        token: "",
        user: {},
        error: "",
      };
    case REGISTER_FAIL:
      return {
        ...state,
        isAuthenticated: false,
        token: "",
        user: {},
        error: action.payload,
      };
    default:
      return state;
  }
}
